<template>
  <exportTemplate ref="exportTemplate" :formModel="formModel" :table-data="tableList" :summary-data="tableSummaryData" :table-total="paginationTotal" :table-load="tableLoading" @set-custom-columns="setCustomColumns" @close-custom-columns="closeCustomColumns" @pagination-change="paginationChange" @form-submit="formSubmit" @form-reset="formReset" @sort="sortChange" @table-export="tableExport" @emitDblclick="emitDblclick">
    <template #form>
      <el-form-item label="日期范围" prop="billDate.selected">
        <date-picker style="width: 100%;" v-model="formModel.billDate.selected" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions"></date-picker>
      </el-form-item>
      <el-form-item label="订货会" prop="salOrderMeet.selected">
        <select-multiple :select-data="formModel.salOrderMeet"></select-multiple>
      </el-form-item>
      <el-form-item label="客户" prop="customer.selected">
        <el-select class="select_multiple" ref="customerSelectRef" style="width: 100%;" v-model="formModel.customer.selected" value-key="value" multiple clearable placeholder="请选择客户名称" @focus="customerInputFocus">
          <el-option v-for="item in formModel.customer.list" :key="item.value" :label="item.text" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属片区" prop="domainDesc.selected">
        <select-multiple :select-data="formModel.domainDesc"></select-multiple>
      </el-form-item>
      <el-form-item label="客户类型" prop="customerTypes.selected">
        <select-multiple :select-data="formModel.customerTypes"></select-multiple>
      </el-form-item>
      <el-form-item label="商品" prop="product.selected">
        <el-select class="select_multiple" style="width: 100%;" ref="productSelectRef" v-model="formModel.product.selected" value-key="value" multiple clearable placeholder="请选择商品名称" @focus="productInputFocus" @change="productChange">
          <el-option v-for="item in formModel.product.list" :key="item.value" :label="item.text" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="大类" prop="brand.selected">
        <select-multiple :select-data="formModel.brand" :change="brandChange"></select-multiple>
      </el-form-item>
      <el-form-item label="小类" prop="brandType.selected">
        <select-multiple :select-data="formModel.brandType"></select-multiple>
      </el-form-item>
      <el-form-item label="品牌" prop="financialBrand.selected">
        <select-multiple :select-data="formModel.financialBrand"></select-multiple>
      </el-form-item>
      <el-form-item prop="stockStatus.selected" style="text-align: center;">
        <el-checkbox v-model="formModel.stockStatus.selected" true-label="" false-label="B">包括还货数量为0的客户</el-checkbox>
      </el-form-item>
    </template>
    <template>
      <el-table-column label="客户" prop="customerName" width="150" fixed></el-table-column>
      <el-table-column label="商品" prop="itemName" width="150" fixed></el-table-column>
      <el-table-column label="订货会" prop="salOrderMeetName" width="150" fixed></el-table-column>
      <el-table-column label="期初数量" prop="monthQty" width="110" sortable="custom"></el-table-column>
      <el-table-column label="期初金额" prop="monthAmt" width="110" sortable="custom" v-if="customColumnList['monthAmt']"></el-table-column>
      <el-table-column label="当期订货数量" prop="sumDHDQty" width="120" sortable="custom"></el-table-column>
      <el-table-column label="当期订货金额" prop="sumDHDAmt" width="120" sortable="custom" v-if="customColumnList['sumDHDAmt']"></el-table-column>
      <el-table-column label="当期还货数量" prop="sumXSDQty" width="120" sortable="custom"></el-table-column>
      <el-table-column label="当期还货金额" prop="sumXSDAmt" width="120" sortable="custom" v-if="customColumnList['sumXSDAmt']"></el-table-column>
      <el-table-column label="剩余数量" prop="onhandQty" width="110" sortable="custom"></el-table-column>
      <el-table-column label="剩余金额" prop="onhandAmt" width="110" sortable="custom" v-if="customColumnList['onhandAmt']"></el-table-column>
    </template>
    <el-dialog title="选择客户" width="90%" :visible.sync="dialogCustomerVisible" custom-class="el-dialog-common dialogDomain dialogCustomer" append-to-body destroy-on-close :close-on-click-modal="false" :close-on-press-escape="false">
      <customerSelect v-if="dialogCustomerVisible" @get-customer="getCustomer" :defaultCheckedKeys="formModel.customer.selected"></customerSelect>
    </el-dialog>
    <el-dialog title="选择商品" :visible.sync="selectProductVisible" width="1080px" append-to-body :close-on-click-modal="false" custom-class="product-dialog">
      <selectProduct v-if="selectProductVisible" :args="{ isFitterEnabled: 'N' }" @get-product-data="getProductData" :default-checked-keys="formModel.product.list"></selectProduct>
    </el-dialog>
  </exportTemplate>
  
</template>

<script>
import exportTemplate from '@/components/common/exportTemplate.vue'
import datePicker from '@/components/common/datePicker.vue'
import customerSelect from '@/components/common/customerSelect.vue'
import selectProduct from '@/components/common/selectProduct.vue'
import { pickerOptions, getNowFormatDate, getAddDate, getQueryItem, exportExcelCommonForVue } from '@/assets/js/common.js'
export default {
  name: 'mainAccount',
  components: {
    exportTemplate,
    datePicker,
    customerSelect,
    selectProduct
  },
  data() {
    return {
      pickerOptions,
      params: {
        page: 1,
        size: 10,
        beginDate: getAddDate(-3),
        endDate: getNowFormatDate()
      },
      formModel: {
        billDate: { submitName: 'billDate', selected: [getAddDate(-3), getNowFormatDate()] },
        salOrderMeet: { submitName: 'salOrderMeetID', selected: {}, valueIsObj: true, size: 'mini', isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择订货会', request: { url: '/Account/dataSearchVue/selectOrderMeetForVue.html', type: 'post', params: { page: 1, size: 10, meetType: 'A', orderMeetType: 'A' }, text: '', value: '' }},
        customer: { submitName: 'customerID', selected: [], list: [] },
        financialBrand: { submitName: 'financialBrandID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false,isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择品牌', request: { url: 'Account/dataSearch/selectFinanceBrandListForVue.html', type: 'post', params: {page: 1, size: 5, isEnabled: 'Y'}, text: '', value: ''}},
        domainDesc: { submitName: 'domainID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择所属片区', request: { url: '/Account/domainDefine/getDomainListForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
        customerTypes: { submitName: 'classifyID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择客户类型', request: { url: '/Account/customerTypeDefine/getCustomerTypesForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
        brand: { submitName: 'brandID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false,isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择大类', request: { url: '/Account/dataSearch/selectBrandListForVue.html', type: 'post', params: {page: 1, size: 5, isPage: 'Y'}, text: '', value: ''}},
        brandType: { submitName: 'itemTypeID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false,isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择小类', request: { url: '/Account/dataSearch/selectTypeListNewForVue.html', type: 'post', params: {page: 1, size: 5, isPage: 'Y'}, text: '', value: ''}},
        product: { submitName: 'itemID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择商品名称', request: { url: '/Account/itemMasterDefine/selectItemMastForVue.html', type: 'post', params: {page: 1, size: 5}, text: '', value: '' }},
        stockStatus: { submitName: 'stockStatus', selected: '' },
      },
      paginationTotal: 0,
      tableList: [],
      tableLoading: false,
      tableSummaryData: {},
      dialogCustomerVisible: false,
      promotionCustomerInfo: [],
      customColumnsList: [
        {
          "label": "期初金额",
          "prop": "monthAmt",
        },
        {
          "label": "当期订货金额",
          "prop": "sumDHDAmt",
        },
        {
          "label": "当期还货金额",
          "prop": "sumXSDAmt",
        },
        {
          "label": "剩余金额",
          "prop": "onhandAmt",
        }
      ],
      customColumn: [],
      selectProductVisible: false
    }
  },
  created() {
    this.getCustomColumnsList()
    this.getTableList()
    this.transmitQuery = JSON.parse(JSON.stringify(this.formModel))
  },
  computed: {
    customColumnList() {
      let tempItem = {}
      this.customColumn.forEach(i => {
        tempItem[i.prop] = (i.isShow == 'Y')
      })
      return tempItem
    }
  },
  methods: {
    setCustomColumns(el) {
      let tempArr = [...this.customColumn]
      el.loading = false
      el.setCustomcolumns(tempArr)
    },
    closeCustomColumns(el) {
      el.$nextTick(async () => {
        let { customColumns } = el
        const { data: res } = await this.$http.post('/Account/customerColumnDefineVue/saveColAndAuthByFuncCode.html', this.Qs.stringify({
          funcCode: 232,
          customSetInfo: JSON.stringify(customColumns)
        }))
        
        if (res.code != 'success') return this.$message.error(res.message)
        this.$message.success(res.message)
      })
    },
    productChange(val) {
      this.formModel.product.list = val
    },
    async getCustomColumnsList() {
      const { data: res } = await this.$http.post(
        "Account/dataSearchVue/selectColumnByFuncCode.html",
        this.Qs.stringify({ funcCode: 232 })
      );
      if (res.code != "success") return this.$confirm(res.message, "提示", {
        confirmButtonText: "确定",
        showCancelButton: false,
        type: "error",
      });
      let result = JSON.parse(res.result);
      let arr = [];
      this.customColumnsList.forEach((item) => {
        result.forEach(($item) => {
          if (item.prop == $item.prop) {
            arr.push({
              id: $item.id,
              label: item.label,
              prop: item.prop,
              isShow: $item.isShow,
            });
          }
        });
      });
      this.customColumn = [...arr]
    },
    paginationChange({page, size, isGetTable = true}) {
      this.params.page = page
      this.params.size = size
      if (isGetTable) {
        this.getTableList()
      }
    },
    formSubmit() {
      this.transmitQuery = JSON.parse(JSON.stringify(this.formModel))
      console.log(this.transmitQuery)
      this.params = { ...this.params, ...getQueryItem(this.formModel) }
      this.getTableList()
    },
    formReset() {
      this.params['sortField'] = ''
      this.params['softBy'] = ''
      this.params.page = 1
    },
    async getTableList() {
      // this.tableList = [
      //   { "itemID":"6146","itemName":"奥特曼","customerID":"1562","customerName":"小路口大峰超市","salOrderMeetID":"506", }
      // ]
      this.tableLoading = true
      this.tableData = []
      const { data: res } = await this.$post(
        "/erpnew/account/c/reada46ceb/salOrdermeetItemMaster/selectOrderMasterList.html",
        this.params
      )
      this.tableLoading = false
      if (res.code != '0') return this.$message.error(res.message)
      let { data, sum, total } = res.data
      this.paginationTotal = total
      this.tableSummaryData = sum
      this.tableList = data
    },
    sortChange({ sortField, sortBy }) {
      this.params['sortField'] = sortField
      this.params['sortBy'] = sortBy
      this.params.page = 1
      this.getTableList()
    },
    tableExport(tabColumn) {
      exportExcelCommonForVue(this.params, tabColumn, '/erpnew/account/c/reada46ceb/salOrdermeetItemMaster/queryOrderMasterListExcelReport.html')
      console.log(tabColumn)
    },
    getCustomer(row) {
      this.formModel.customer.selected = [...row]
      this.formModel.customer.list = [...row]
      this.dialogCustomerVisible = false
      
    },
    customerInputFocus () {
      this.$refs['customerSelectRef'].blur()
      this.dialogCustomerVisible = true
    },
    productInputFocus() {
      this.$refs['productSelectRef'].blur()
      this.selectProductVisible = true
    },
    getProductData(data) {
      this.selectProductVisible = false
      this.formModel.product.selected = data
      this.formModel.product.list = data
    },
    rowDblclick(row) {
    //   let options = this.Qs.stringify({
    //     billDate: this.formModel.billDate.selected,
    //     customer: { text: row.customerName, value: row.customerID },
    //     item: { text: row.itemName, value: row.itemID },
    //     salOrderMeet: { text: row.salOrderMeetName, value: row.salOrderMeetID },
    //   })
    //   console.log(options);
      // let url = `/templates/vue-account/dist/index.htm#/dataSearchReconciliationDetailed?${options}`
      // this.$refs.exportTemplate.toJump('客户对账明细', url)
    },
    emitDblclick(row) {
      console.log(row)
      console.log(this.transmitQuery)
      this.formSubmit()
      for(let i in row) {
          Object.keys(this.transmitQuery).map((key) => {
            if(row[i] && i === this.transmitQuery[key].submitName) {
              let arr = []
                if(this.transmitQuery[key].selected.length) {
                    arr = this.transmitQuery[key].selected.filter(item => { return item.value === row[i] }) 
                } else {
                    let str = i.replace('ID','Name')
                    let obj = { value: row[i], text: row[str] }
                    arr.push(obj)
                    if(i === 'itemID' || i === 'customerID') {
                        this.transmitQuery[key].list = arr
                    }
                }
                this.transmitQuery[key].selected = arr
            }
          })
      }
      console.log(this.transmitQuery)
      let width = window.top.document.browser.availiframeWidth.value
      let height = window.top.document.browser.availiframeHeight.value
      let timestemp = new Date().getTime()
      this.transmitQuery.timestemp = timestemp
      top.addPanel('订还货流水', `/templates/vue-account/dist/index.htm#/dataSearchOrderReconciliationTurnover?type=1&timestemp=${timestemp}`, width, height, true, this.transmitQuery)
    },
    brandChange(val) {
      let str = val.map(item => "'" + item.value + "'").join(',')
      this.formModel.brandType.request.params['brandID'] = str
      this.formModel.brandType.isReSearch = true
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .dialogCustomer {
  height: 90vh;
  display: flex;
  flex-direction: column;
  flex: 1;
  flex-basis: auto;
  box-sizing: border-box;
  min-width: 0;
  .el-dialog__header,
  .el-card__header {
    box-sizing: border-box;
    flex-shrink: 0;
  }
  .el-dialog__body {
    flex: 1;
    flex-basis: auto;
    box-sizing: border-box;
    overflow: auto;
  }
}
</style>